import MuiButton from '@material-ui/core/Button';
import styled from 'styled-components';

const ThemeButton = styled(MuiButton)<{
  $color?: string;
  $upperCase?: boolean;
  $height?: string;
  $fillSpace?: boolean;
}>`
  && {
    background: ${({ $color }) => ($color ? $color : (props) => props.theme.colors.malibu)};
    border-radius: 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #ffffff !important;
    flex-shrink: 0;
    flex-grow: ${({ $fillSpace }) => ($fillSpace ? '1' : '0')};
    padding: 8px 20px;
    text-transform: ${({ $upperCase }) => ($upperCase ? 'uppercase' : 'initial')};
    height: ${({ $height }) => ($height ? $height : 'auto')};
    :disabled {
      opacity: 1;
      background-color: #757677 !important;
    }
    &:hover {
      color: #ffffff;
      background: ${({ $color }) => ($color ? $color : (props) => props.theme.colors.malibu)};
    }
  }
`;

export default ThemeButton;
